export enum CreditCard {
  CHASE_FREEDOM_UNLIMITED_CREDIT_CARD = "CHASE_FREEDOM_UNLIMITED_CREDIT_CARD",
  CHASE_FREEDOM_FLEX_CREDIT_CARD = "CHASE_FREEDOM_FLEX_CREDIT_CARD",
  CHASE_FREEDOM_RISE_CREDIT_CARD = "CHASE_FREEDOM_RISE_CREDIT_CARD",
  CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD = "CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD",
  CHASE_SAPPHIRE_RESERVE_CREDIT_CARD = "CHASE_SAPPHIRE_RESERVE_CREDIT_CARD",
  SLATE_EDGE_CREDIT_CARD = "SLATE_EDGE_CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PRIORITY__CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PRIORITY__CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD",
  UNITEDU00SMS_EXPLORER_CARD = "UNITEDU00SMS_EXPLORER_CARD",
  UNITED_QUESTU00SMS_CARD = "UNITED_QUESTU00SMS_CARD",
  UNITED_GATEWAYU00SMS_CREDIT_CARD = "UNITED_GATEWAYU00SMS_CREDIT_CARD",
  UNITED_CLUBU00SMS_INFINITE_CARD = "UNITED_CLUBU00SMS_INFINITE_CARD",
  MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD = "MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD",
  MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD = "MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD",
  MARRIOTT_BONVOY_BOLD_CREDIT_CARD = "MARRIOTT_BONVOY_BOLD_CREDIT_CARD",
  IHG_ONE_REWARDS_PREMIER_CREDIT_CARD = "IHG_ONE_REWARDS_PREMIER_CREDIT_CARD",
  IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD = "IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD",
  DISNEY_PREMIER_VISA_CARD = "DISNEY_PREMIER_VISA_CARD",
  DISNEY_VISA_CARD = "DISNEY_VISA_CARD",
  WORLD_OF_HYATT_CREDIT_CARD = "WORLD_OF_HYATT_CREDIT_CARD",
  AEROPLAN_CARD = "AEROPLAN_CARD",
  BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD = "BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD",
  AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD = "AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD",
  IBERIA_VISA_SIGNATURE_CREDIT_CARD = "IBERIA_VISA_SIGNATURE_CREDIT_CARD",
  PRIME_VISA = "PRIME_VISA",
  AMAZON_VISA = "AMAZON_VISA",
  DOORDASH_REWARDS_MASTERCARD = "DOORDASH_REWARDS_MASTERCARD",
  INK_BUSINESS_UNLIMITED_CREDIT_CARD = "INK_BUSINESS_UNLIMITED_CREDIT_CARD",
  INK_BUSINESS_PREFERRED_CREDIT_CARD = "INK_BUSINESS_PREFERRED_CREDIT_CARD",
  INK_BUSINESS_CASH_CREDIT_CARD = "INK_BUSINESS_CASH_CREDIT_CARD",
  INK_BUSINESS_PREMIER_CREDIT_CARD = "INK_BUSINESS_PREMIER_CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD",
  SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD = "SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD",
  UNITEDU00SMS_BUSINESS_CARD = "UNITEDU00SMS_BUSINESS_CARD",
  UNITED_CLUBU00SMS_BUSINESS__CARD = "UNITED_CLUBU00SMS_BUSINESS__CARD",
  IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD = "IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD",
  WORLD_OF_HYATT_BUSINESS_CREDIT_CARD = "WORLD_OF_HYATT_BUSINESS_CREDIT_CARD",
  THE_PLATINUM_CARD = "THE_PLATINUM_CARD",
  AMERICAN_EXPRESS_GOLD_CARD = "AMERICAN_EXPRESS_GOLD_CARD",
  BLUE_CASH_PREFERRED_CARD = "BLUE_CASH_PREFERRED_CARD",
  BLUE_CASH_EVERYDAY_CARD = "BLUE_CASH_EVERYDAY_CARD",
  DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD = "DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD",
  DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD = "DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD",
  MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD = "MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD",
  MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD = "MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD",
  HILTON_HONORS_AMERICAN_EXPRESS_CARD = "HILTON_HONORS_AMERICAN_EXPRESS_CARD",
  HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD = "HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD",
  DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD = "DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD",
  AMERICAN_EXPRESS_GREEN_CARD = "AMERICAN_EXPRESS_GREEN_CARD",
  HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD = "HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD",
  DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD = "DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD",
  BUSINESS_PLATINUM_CARD = "BUSINESS_PLATINUM_CARD",
  BUSINESS_GOLD_CARD = "BUSINESS_GOLD_CARD",
  BLUE_BUSINESS_CASHTM_CARD = "BLUE_BUSINESS_CASHTM_CARD",
  BLUE_BUSINESS_PLUS_CREDIT_CARD = "BLUE_BUSINESS_PLUS_CREDIT_CARD",
  PLUM_CARD = "PLUM_CARD",
  BUSINESS_GREEN_REWARDS_CARD = "BUSINESS_GREEN_REWARDS_CARD",
  DELTA_SKYMILES_RESERVE_BUSINESS_CARD = "DELTA_SKYMILES_RESERVE_BUSINESS_CARD",
  DELTA_SKYMILES_PLATINUM_BUSINESS_CARD = "DELTA_SKYMILES_PLATINUM_BUSINESS_CARD",
  DELTA_SKYMILES_GOLD_BUSINESS_CARD = "DELTA_SKYMILES_GOLD_BUSINESS_CARD",
  MARRIOTT_BONVOY_BUSINESS_CARD = "MARRIOTT_BONVOY_BUSINESS_CARD",
  HILTON_HONORS_BUSINESS_CARD = "HILTON_HONORS_BUSINESS_CARD",
  AMAZON_BUSINESS_PRIME_CARD = "AMAZON_BUSINESS_PRIME_CARD",
  AMAZON_BUSINESS_CARD = "AMAZON_BUSINESS_CARD",
  BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS = "BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS",
  BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS = "BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS",
  BANKAMERICARD = "BANKAMERICARD",
  BANK_OF_AMERICA_TRAVEL_REWARDS = "BANK_OF_AMERICA_TRAVEL_REWARDS",
  BANK_OF_AMERICA_PREMIUM_REWARDS = "BANK_OF_AMERICA_PREMIUM_REWARDS",
  BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE = "BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE",
  BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS = "BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS",
  BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS = "BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS",
  BANKAMERICARD_FOR_STUDENTS = "BANKAMERICARD_FOR_STUDENTS",
  BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS = "BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS",
  BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED = "BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED",
  BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED = "BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED",
  BANKAMERICARD_SECURED = "BANKAMERICARD_SECURED",
  BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED = "BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED",
  ALASKA_AIRLINES_VISA_SIGNATURE = "ALASKA_AIRLINES_VISA_SIGNATURE",
  SUSAN_G_KOMEN_CUSTOMIZED_CASH_REWARDS = "SUSAN_G_KOMEN_CUSTOMIZED_CASH_REWARDS",
  FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD = "FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD",
  ALLWAYS_REWARDS_VISA = "ALLWAYS_REWARDS_VISA",
  AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD = "AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD",
  ROYAL_CARIBBEAN_VISA_SIGNATURE = "ROYAL_CARIBBEAN_VISA_SIGNATURE",
  NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD = "NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD",
  CELEBRITY_CRUISES_VISA_SIGNATURE = "CELEBRITY_CRUISES_VISA_SIGNATURE",
  BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD = "BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD",
  BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD = "BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD",
  BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD = "BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD",
  ALASKA_AIRLINES_BUSINESS_CREDIT_CARD = "ALASKA_AIRLINES_BUSINESS_CREDIT_CARD",
  PLATINUM_PLUS_MASTERCARD_BUSINESS_CARD = "PLATINUM_PLUS_MASTERCARD_BUSINESS_CARD",
  BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_MASTERCARD_SECURED_CREDIT_CARD = "BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_MASTERCARD_SECURED_CREDIT_CARD",
  PLATINUM_MASTERCARD = "PLATINUM_MASTERCARD",
  VENTURE_X_REWARDS = "VENTURE_X_REWARDS",
  VENTURE_REWARDS = "VENTURE_REWARDS",
  VENTUREONE_REWARDS = "VENTUREONE_REWARDS",
  VENTUREONE_REWARDS_FOR_GOOD_CREDIT = "VENTUREONE_REWARDS_FOR_GOOD_CREDIT",
  QUICKSILVER_REWARDS = "QUICKSILVER_REWARDS",
  QUICKSILVER_REWARDS_FOR_GOOD_CREDIT = "QUICKSILVER_REWARDS_FOR_GOOD_CREDIT",
  SAVOR_REWARDS = "SAVOR_REWARDS",
  SAVOR_REWARDS_FOR_GOOD_CREDIT = "SAVOR_REWARDS_FOR_GOOD_CREDIT",
  QUICKSILVERONE_REWARDS = "QUICKSILVERONE_REWARDS",
  SAVOR_REWARDS_FOR_STUDENTS = "SAVOR_REWARDS_FOR_STUDENTS",
  QUICKSILVER_REWARDS_FOR_STUDENTS = "QUICKSILVER_REWARDS_FOR_STUDENTS",
  QUICKSILVER_SECURED_REWARDS = "QUICKSILVER_SECURED_REWARDS",
  PLATINUM_SECURED = "PLATINUM_SECURED",
  KOHLS_REWARDS_VISA = "KOHLS_REWARDS_VISA",
  REI_COOP_MASTERCARD = "REI_COOP_MASTERCARD",
  POTTERY_BARN_KEY_REWARDS_VISA = "POTTERY_BARN_KEY_REWARDS_VISA",
  WILLIAMS_SONOMA_KEY_REWARDS_VISA = "WILLIAMS_SONOMA_KEY_REWARDS_VISA",
  WEST_ELM_KEY_REWARDS_VISA = "WEST_ELM_KEY_REWARDS_VISA",
  THE_KEY_REWARDS_VISA = "THE_KEY_REWARDS_VISA",
  SPARK_2_CASH_PLUS = "SPARK_2_CASH_PLUS",
  SPARK_2_CASH = "SPARK_2_CASH",
  SPARK_15_CASH_SELECT = "SPARK_15_CASH_SELECT",
  SPARK_CLASSIC = "SPARK_CLASSIC",
  VENTURE_X_BUSINESS = "VENTURE_X_BUSINESS",
  SPARK_2X_MILES = "SPARK_2X_MILES",
  SPARK_15X_MILES_SELECT = "SPARK_15X_MILES_SELECT",
  CABELAS_CLUB_CARD = "CABELAS_CLUB_CARD",
  BASS_PRO_SHOPS_CLUB_CARD = "BASS_PRO_SHOPS_CLUB_CARD",
  BASS_PRO_SHOPS_AND_CABELAS_CLUB_BUSINESS_MASTERCARD = "BASS_PRO_SHOPS_AND_CABELAS_CLUB_BUSINESS_MASTERCARD",
  BJS_ONE_MASTERCARD = "BJS_ONE_MASTERCARD",
  DISCOVER_IT_CASH_BACK_CREDIT_CARD = "DISCOVER_IT_CASH_BACK_CREDIT_CARD",
  DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD = "DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD",
  DISCOVER_IT_SECURED_CREDIT_CARD = "DISCOVER_IT_SECURED_CREDIT_CARD",
  DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD = "DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD",
  DISCOVER_IT_MILES_CREDIT_CARD = "DISCOVER_IT_MILES_CREDIT_CARD",
  NHL_DISCOVER_IT_CREDIT_CARD = "NHL_DISCOVER_IT_CREDIT_CARD",
  DISCOVER_IT_CHROME_GAS__RESTAURANT_CREDIT_CARD = "DISCOVER_IT_CHROME_GAS__RESTAURANT_CREDIT_CARD",
  ACTIVE_CASH_CARD = "ACTIVE_CASH_CARD",
  AUTOGRAPH_JOURNEY_CARD = "AUTOGRAPH_JOURNEY_CARD",
  AUTOGRAPH_CARD = "AUTOGRAPH_CARD",
  REFLECT_CARD = "REFLECT_CARD",
  ATTUNE_CARD = "ATTUNE_CARD",
  BILT_MASTERCARD = "BILT_MASTERCARD",
  ONE_KEY_CARD = "ONE_KEY_CARD",
  CHOICE_PRIVILEGES_MASTERCARD = "CHOICE_PRIVILEGES_MASTERCARD",
  CHOICE_PRIVILEGES_SELECT_MASTERCARD = "CHOICE_PRIVILEGES_SELECT_MASTERCARD",
  SIGNIFY_BUSINESS_CARD = "SIGNIFY_BUSINESS_CARD",
  CITI_DOUBLE_CASH_CARD = "CITI_DOUBLE_CASH_CARD",
  CITI_SIMPLICITY_CREDIT_CARD = "CITI_SIMPLICITY_CREDIT_CARD",
  CITI_DIAMOND_PREFERRED_CREDIT_CARD = "CITI_DIAMOND_PREFERRED_CREDIT_CARD",
  CITI_CUSTOM_CASH_CARD = "CITI_CUSTOM_CASH_CARD",
  AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD = "AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD",
  CITI_STRATA_PREMIER_CARD = "CITI_STRATA_PREMIER_CARD",
  CITI_REWARDS_STUDENT_CREDIT_CARD = "CITI_REWARDS_STUDENT_CREDIT_CARD",
  CITI_REWARDS_CREDIT_CARD = "CITI_REWARDS_CREDIT_CARD",
  COSTCO_ANYWHERE_VISA_CARD_BY_CITI = "COSTCO_ANYWHERE_VISA_CARD_BY_CITI",
  CITI__AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD = "CITI__AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD",
  CITI__AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD = "CITI__AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD",
  AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD = "AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD",
  ATT_POINTS_PLUS_CARD_FROM_CITI = "ATT_POINTS_PLUS_CARD_FROM_CITI",
  COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI = "COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI",
  CITI_SECURED_MASTERCARD = "CITI_SECURED_MASTERCARD",
  SHOP_YOUR_WAY_MASTERCARD = "SHOP_YOUR_WAY_MASTERCARD",
  MY_BEST_BUY_CREDIT_CARDS = "MY_BEST_BUY_CREDIT_CARDS",
  THE_HOME_DEPOT_CONSUMER_CREDIT_CARD = "THE_HOME_DEPOT_CONSUMER_CREDIT_CARD",
  TSC_CREDIT_CARDS = "TSC_CREDIT_CARDS",
  LL_BEAN_MASTERCARD = "LL_BEAN_MASTERCARD",
  SHELL__FUEL_REWARDS_CREDIT_CARDS = "SHELL__FUEL_REWARDS_CREDIT_CARDS",
  EXXON_MOBIL_SMART_CARD_CREDIT_CARD = "EXXON_MOBIL_SMART_CARD_CREDIT_CARD",
  US_BANK_SMARTLY_VISA_SIGNATURE_CARD = "US_BANK_SMARTLY_VISA_SIGNATURE_CARD",
  US_BANK_CASH_VISA_SIGNATURE_CARD = "US_BANK_CASH_VISA_SIGNATURE_CARD",
  US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD = "US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD",
  US_BANK_VISA_PLATINUM_CARD = "US_BANK_VISA_PLATINUM_CARD",
  US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD = "US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD",
  US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD = "US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD",
  US_BANK_ALTITUDE_GO_SECURED_VISA_CARD = "US_BANK_ALTITUDE_GO_SECURED_VISA_CARD",
  US_BANK_CASH_SECURED_VISA_CARD = "US_BANK_CASH_SECURED_VISA_CARD",
  US_BANK_SECURED_VISA_CARD = "US_BANK_SECURED_VISA_CARD",
  EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD = "EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD",
  BREEZE_EASYVISA_CREDIT_CARD = "BREEZE_EASYVISA_CREDIT_CARD",
  XBOX_MASTERCARD = "XBOX_MASTERCARD",
  JETBLUE_PLUS_CARD = "JETBLUE_PLUS_CARD",
  ATHLETA_REWARDS_MASTERCARD = "ATHLETA_REWARDS_MASTERCARD",
  NAVYIST_REWARDS_MASTERCARD = "NAVYIST_REWARDS_MASTERCARD",
  WYNDHAM_REWARDS_EARNER_BUSINESS_CARD = "WYNDHAM_REWARDS_EARNER_BUSINESS_CARD",
  GAP_GOOD_REWARDS_MASTERCARD = "GAP_GOOD_REWARDS_MASTERCARD",
  HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD = "HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD",
  JETBLUE_BUSINESS_CARD = "JETBLUE_BUSINESS_CARD",
  UPROMISEWORLD_MASTERCARD = "UPROMISEWORLD_MASTERCARD",
  FRONTIER_AIRLINES_WORLD_MASTERCARD = "FRONTIER_AIRLINES_WORLD_MASTERCARD",
  WYNDHAM_REWARDS_EARNER_PLUS_CARD = "WYNDHAM_REWARDS_EARNER_PLUS_CARD",
  AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD = "AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD",
  MILES__MOREWORLD_ELITE_MASTERCARD = "MILES__MOREWORLD_ELITE_MASTERCARD",
  WYNDHAM_REWARDS_EARNERCARD = "WYNDHAM_REWARDS_EARNERCARD",
  EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD = "EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD",
  HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD = "HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD",
  BANANA_REPUBLIC_REWARDS_MASTERCARD = "BANANA_REPUBLIC_REWARDS_MASTERCARD",
  CAPITAL_VACATIONSWORLD_MASTERCARD = "CAPITAL_VACATIONSWORLD_MASTERCARD",
  RCIELITE_REWARDSWORLD_MASTERCARD = "RCIELITE_REWARDSWORLD_MASTERCARD",
  JETBLUE_CARD = "JETBLUE_CARD",
  BARNES__NOBLE_MASTERCARD = "BARNES__NOBLE_MASTERCARD",
  BARCLAYS_EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARDU00AE = "BARCLAYS_EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARDU00AE",
  TD_DOUBLE_UP_CREDIT_CARD = "TD_DOUBLE_UP_CREDIT_CARD",
  TD_CASH_CREDIT_CARD = "TD_CASH_CREDIT_CARD",
  TD_FLEXPAY_CREDIT_CARD = "TD_FLEXPAY_CREDIT_CARD",
  TD_CLEAR_VISA_PLATINUM_CREDIT_CARD_WITH_A_1000_CREDIT_LIMIT = "TD_CLEAR_VISA_PLATINUM_CREDIT_CARD_WITH_A_1000_CREDIT_LIMIT",
  TD_CLEAR_VISA_PLATINUM_CREDIT_CARD_WITH_A_2000_CREDIT_LIMIT = "TD_CLEAR_VISA_PLATINUM_CREDIT_CARD_WITH_A_2000_CREDIT_LIMIT",
  TD_FIRST_CLASS_VISA_SIGNATURE_CREDIT_CARD = "TD_FIRST_CLASS_VISA_SIGNATURE_CREDIT_CARD",
  TD_CASH_SECURED_CREDIT_CARD = "TD_CASH_SECURED_CREDIT_CARD",
  TD_BUSINESS_SOLUTIONS_CREDIT_CARD = "TD_BUSINESS_SOLUTIONS_CREDIT_CARD",
  HSBC_PREMIER_CREDIT_CARD = "HSBC_PREMIER_CREDIT_CARD",
  HSBC_ELITE_CREDIT_CARD = "HSBC_ELITE_CREDIT_CARD",
  SAMS_CLUB_CREDIT_CARD = "SAMS_CLUB_CREDIT_CARD",
  ASHLEY_ADVANTAGE_CREDIT_CARD = "ASHLEY_ADVANTAGE_CREDIT_CARD",
  GOOGLE_STORE_FINANCING = "GOOGLE_STORE_FINANCING",
  REAL_REWARDS_CREDIT_CARD = "REAL_REWARDS_CREDIT_CARD",
  MYLOWES_REWARDS_CREDIT_CARD = "MYLOWES_REWARDS_CREDIT_CARD",
  ROOMS_TO_GO_CREDIT_CARD = "ROOMS_TO_GO_CREDIT_CARD",
  PAYPAL_CREDIT = "PAYPAL_CREDIT",
  VERIZON_VISA_CARD = "VERIZON_VISA_CARD",
  SYNCHRONY_LUXURY_CREDIT_CARD = "SYNCHRONY_LUXURY_CREDIT_CARD",
  SYNCHRONY_SEWING__MORE_CREDIT_CARD = "SYNCHRONY_SEWING__MORE_CREDIT_CARD",
  JCPENNEY_CREDIT_CARD = "JCPENNEY_CREDIT_CARD",
  VENMO_VISA_CREDIT_CARD = "VENMO_VISA_CREDIT_CARD",
  SYNCHRONY_MUSIC__SOUND_CREDIT_CARD = "SYNCHRONY_MUSIC__SOUND_CREDIT_CARD",
  CARECREDIT_CREDIT_CARD = "CARECREDIT_CREDIT_CARD",
  MYWALGREENS_CREDIT_CARD = "MYWALGREENS_CREDIT_CARD",
  SYNCHRONY_HOME_CREDIT_CARD = "SYNCHRONY_HOME_CREDIT_CARD",
  QCARD_CREDIT_CARD = "QCARD_CREDIT_CARD",
  SYNCHRONY_OUTDOORS_CREDIT_CARD = "SYNCHRONY_OUTDOORS_CREDIT_CARD",
  SPORTING_GOODS_CREDIT_CARDS = "SPORTING_GOODS_CREDIT_CARDS",
  MATTRESS_FIRM_CREDIT_CARD = "MATTRESS_FIRM_CREDIT_CARD",
  PAYPAL_CASHBACK_WORLD_MASTERCARD = "PAYPAL_CASHBACK_WORLD_MASTERCARD",
  SYNCHRONY_HOME_IMPROVEMENT_CREDIT_CARD = "SYNCHRONY_HOME_IMPROVEMENT_CREDIT_CARD",
  SYNCHRONY_PREMIER_WORLD_MASTERCARD = "SYNCHRONY_PREMIER_WORLD_MASTERCARD",
  SYNCHRONY_CAR_CARE_CREDIT_CARD = "SYNCHRONY_CAR_CARE_CREDIT_CARD",
  SYNCHRONY_SAMS_CLUB_CREDIT_CARD = "SYNCHRONY_SAMS_CLUB_CREDIT_CARD",
  MY_GM_REWARDS_MASTERCARD = "MY_GM_REWARDS_MASTERCARD",
  GM_EXTENDED_FAMILY_MASTERCARD = "GM_EXTENDED_FAMILY_MASTERCARD",
  GM_BUSINESS_MASTERCARD = "GM_BUSINESS_MASTERCARD",
  APPLE_CARD = "APPLE_CARD",
  PLATINUM_X5_VISA = "PLATINUM_X5_VISA",
  CREDIT_ONE_BANK_AMERICAN_EXPRESS_CARD = "CREDIT_ONE_BANK_AMERICAN_EXPRESS_CARD",
  PLATINUM_VISA_FOR_REBUILDING_CREDIT = "PLATINUM_VISA_FOR_REBUILDING_CREDIT",
  CREDIT_ONE_BANK_WANDER_AMERICAN_EXPRESS_CARD = "CREDIT_ONE_BANK_WANDER_AMERICAN_EXPRESS_CARD",
  PLATINUM_REWARDS_VISA_WITH_NO_ANNUAL_FEE = "PLATINUM_REWARDS_VISA_WITH_NO_ANNUAL_FEE",
  PLATINUM_VISA = "PLATINUM_VISA",
  SECURED_CARD = "SECURED_CARD",
  NASCAR_AMERICAN_EXPRESS_CARD = "NASCAR_AMERICAN_EXPRESS_CARD",
  VEGAS_GOLDEN_KNIGHTS_CREDIT_CARD = "VEGAS_GOLDEN_KNIGHTS_CREDIT_CARD",
  BEST_FRIENDS_CREDIT_CARD = "BEST_FRIENDS_CREDIT_CARD",
  EVERGREENBY_FNBO_CREDIT_CARD = "EVERGREENBY_FNBO_CREDIT_CARD",
  GETAWAY_BY_FNBOCREDIT_CARD = "GETAWAY_BY_FNBOCREDIT_CARD",
  SECURED_VISACREDIT_CARD = "SECURED_VISACREDIT_CARD",
};